<template>
  <div class="mx-auto">
    <b-row>
      <b-col xxs="12">
        <div class="row mt-5">
          <div class="col">
            <h1 class="font-weight-boldest mega-text m-0 p-0">Pricing</h1>
            <h6 class="font-weight-bold">
              Your first property FREE.
            </h6>

          

            <div class="card my-5">
              <div class="card-body">
                <table class="table">
                  <tr class="bg-light">
                    <td class="text-info border-0" >
                      <strong>Properties</strong>
                    </td>
                    <td class="text-info border-0">
                      <strong>Price Per Property Per Month</strong>
                    </td>
                  </tr>
                  <tr>
                    <td>2 - 10</td>
                    <td>$0.50</td>
                  </tr>
                  <tr>
                    <td>11 - 100</td>
                    <td>$0.35</td>
                  </tr>
                  <tr>
                    <td>101+</td>
                    <td>$0.20</td>
                  </tr>
                </table>
                <ul>
                 
                  <li>$0.01 per email sent.</li>
                  <li>
                    $0.35 per 100mb or part there off for storage space used for
                    files and images.
                    <ul>
                      <li>
                        Images are automatically resized and compressed to save
                        space.
                      </li>
                    </ul>
                  </li>
                  <li>Billed Monthly.</li>
                </ul>

                <router-link
                  :to="{ name: 'register' }"
                  class="btn btn-primary btn-lg mb-5 mt-5"
                  >Get Started For Free</router-link
                >
              </div>
            </div>

              <b-alert variant="success" class="p-5 my-5" show>
              <b-media>
                <template #aside>
                  <i class="lni lni-offer font-size-26"></i>
                </template>

                <h5>Start Free</h5>
                Your first property &amp; first Email with 10mb disc space for
                <strong> free every month. </strong>
              </b-media>
            </b-alert>


          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      appName: process.env.VUE_APP_APP_NAME,
    };
  },
};
</script>
